var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3188_78330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 14.1406V11.5625C4.6875 11.1067 4.86858 10.6695 5.19091 10.3472C5.51324 10.0248 5.95041 9.84375 6.40625 9.84375H13.2813C13.7371 9.84375 14.1743 10.0248 14.4966 10.3472C14.8189 10.6695 15 11.1067 15 11.5625V14.1406",
    stroke: "#77838D",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.1406V11.5625C15 11.1067 15.1811 10.6695 15.5034 10.3472C15.8257 10.0248 16.2629 9.84375 16.7188 9.84375H23.5938C24.0496 9.84375 24.4868 10.0248 24.8091 10.3472C25.1314 10.6695 25.3125 11.1067 25.3125 11.5625V14.1406",
    stroke: "#77838D",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40104 14.1406H25.599C26.2067 14.1406 26.7896 14.3821 27.2194 14.8118C27.6492 15.2416 27.8906 15.8245 27.8906 16.4323V21.875H2.10938V16.4323C2.10938 15.8245 2.35082 15.2416 2.78059 14.8118C3.21036 14.3821 3.79325 14.1406 4.40104 14.1406Z",
    stroke: "#77838D",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 21.875V25.3125",
    stroke: "#77838D",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8906 21.875V25.3125",
    stroke: "#77838D",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 14.1406V6.40625C25.3125 5.95041 25.1314 5.51324 24.8091 5.19091C24.4868 4.86858 24.0496 4.6875 23.5938 4.6875H6.40625C5.95041 4.6875 5.51324 4.86858 5.19091 5.19091C4.86858 5.51324 4.6875 5.95041 4.6875 6.40625V14.1406",
    stroke: "#77838D",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3188_78330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    transform: "translate(1.25 1.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleBed);
export default __webpack_public_path__ + "static/media/double_bed.6389ff0e.svg";
export { ForwardRef as ReactComponent };